import React, { Component } from 'react';
import {
  Link,
  withRouter,
} from 'react-router-dom';

import { auth, db } from '../firebase';
import * as routes from '../constants/routes';
import {Navbar, Icon} from 'react-materialize'

const SignUpPage = ({ history }) =>
  <div>
    <div className="section"></div>
    <center>
    <h5>Criar uma conta</h5>
    </center>

      <div className="section"></div>
    <SignUpForm history={history} />
  </div>

  const INITIAL_STATE = {
    username: '',
    email: '',
    passwordOne: '',
    passwordTwo: '',
    error: null,
  };

  const byPropKey = (propertyName, value) => () => ({
    [propertyName]: value,
  });


class SignUpForm extends Component {
  constructor(props) {
    super(props);

     this.state = { ...INITIAL_STATE };
  }

  onSubmit = (event) => {
    const {
      username,
      email,
      passwordOne,
    } = this.state;

    const {
          history,
        } = this.props;


    auth.doCreateUserWithEmailAndPassword(email, passwordOne)
      .then(authUser => {
        db.doCreateUser(authUser.uid, username, email)
          .then(() => {
            this.setState(() => ({ ...INITIAL_STATE }));
            history.push(routes.HOME);
          })
          .catch(error => {
            this.setState(byPropKey('error', error));
          });

        // this.setState(() => ({ ...INITIAL_STATE }));
        // history.push(routes.HOME);
      })
      .catch(error => {
        this.setState(byPropKey('error', error));
      });

    event.preventDefault();
  }

  render() {
    const {
      username,
      email,
      passwordOne,
      passwordTwo,
      error,
    } = this.state;

    const isInvalid =
         passwordOne !== passwordTwo ||
         passwordOne === '' ||
         email === '' ||
         username === '';


    return (
      <div className="container">
        <center>
        <div className="z-depth-1 grey lighten-4 row" >

          <form className="col s12" onSubmit={this.onSubmit}>

          <div className='row'>
            <div className='col s12'>
            </div>
          </div>
          <div className="row">
                <div className="row">
                  <div className="input-field col s12">
                    <input
                      className='validate'
                      type='text'
                      name='username'
                      id='username'
                      value={username}
                      onChange={event => this.setState(byPropKey('username', event.target.value))}
                    />
                    <label htmlFor="username">Nome Completo</label>
                  </div>
                </div>
                <div className="row">
                  <div className="input-field col s12">
                    <input
                        className='validate'
                        type='email'
                        name='email'
                        id='email'
                        value={email}
                        onChange={event => this.setState(byPropKey('email', event.target.value))}
                      />
                    <label htmlFor="email">Email</label>
                  </div>
                </div>
                <div className="row">
                  <div className="input-field col s12">
                    <input
                      className='validate'
                      type='password'
                      name='passwordOne'
                      id='passwordOne'
                      value={passwordOne}
                      onChange={event => this.setState(byPropKey('passwordOne', event.target.value))}
                    />
                    <label htmlFor="passwordOne">Senha</label>
                  </div>
                </div>
                <div className="row">
                  <div className="input-field col s12">
                    <input
                      className='validate'
                      type='password'
                      name='passwordTwo'
                      id='passwordTwo'
                      value={passwordTwo}
                      onChange={event => this.setState(byPropKey('passwordTwo', event.target.value))}
                    />
                    <label htmlFor="passwordTwo">Confirme a senha</label>
                  </div>
                </div>
            </div>
            <br />
            <center>
              <div className='row'>
                <button type='submit' name='btn_login' className='col s12 btn btn-large waves-effect indigo'>Criar conta<Icon>keyboard_arrow_right</Icon></button>
              </div>
            </center>
            <div className='row'>
              <div className='col s12'>
                { error && <center>{error.message}</center> }
              </div>
            </div>

      </form>

    </div>

    <p>
      Já tem uma conta?
      {' '}
      <Link to={routes.SIGN_IN}>Entre aqui</Link>
    </p>
    </center>
  </div>
    );
  }
}

const SignUpLink = () =>
  <p>
    Não tem uma conta?
    {' '}
    <Link to={routes.SIGN_UP}>Crie uma agora</Link>
  </p>


export default withRouter(SignUpPage);


export {
  SignUpForm,
  SignUpLink,
};



// WEBPACK FOOTER //
// ./src/components/SignUp.js